import { render, staticRenderFns } from "./DataSetManager.vue?vue&type=template&id=f0284458&scoped=true"
import script from "./DataSetManager.vue?vue&type=script&lang=js"
export * from "./DataSetManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0284458",
  null
  
)

export default component.exports